export const SP_STATUS = 'status'
export const SP_TIPS = 'withTips'
export const SP_FROM_NOTIFICATION = 'fromNotification'
export const SP_COMPANY_ID = 'companyId'
export const SP_PAGE = 'page'
export const SP_PAGE_SIZE = 'pageSize'
